import React, { Component } from "react";
import { FormattedMessage, defineMessages } from "react-intl";
import Form from "assets/scripts/components/common/form/Form/Form";
import mapBackendErrors from "assets/scripts/utils/mapBackendErrors";
import tryParseNumber from "assets/scripts/utils/tryParseNumber";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
import { REQUIRED } from "assets/scripts/constants/FormMessages";
const messages = defineMessages({
    submit: {
        id: "forms.accountAdd.submit",
        defaultMessage: "Add Account"
    },
    referenceNumberLabel: {
        id: "forms.accountAdd.referenceNumber.label",
        defaultMessage: "Reference/File Number"
    },
    referenceNumberHelp: {
        id: "forms.accountAdd.referenceNumber.help",
        defaultMessage: "Numbers only"
    },
    pinLabel: {
        id: "forms.accountAdd.pin.label",
        defaultMessage: "PIN"
    },
    pinHelp: {
        id: "forms.accountAdd.pin.help",
        defaultMessage: "Numbers only"
    }
});
function getErrors(value, accounts) {
    const referenceNumber = tryParseNumber(value.referenceNumber);
    let referenceNumberError = null;
    if (referenceNumber == null || referenceNumber <= 0) {
        referenceNumberError = REQUIRED;
    }
    else if (accounts.some(it => it.refNum === referenceNumber)) {
        referenceNumberError = (<FormattedMessage id="forms.accountAdd.referenceNumber.error.accountExists" defaultMessage="You have already added this account"/>);
    }
    return {
        referenceNumber: referenceNumberError,
        pin: tryParseNumber(value.pin) == null ? REQUIRED : null,
    };
}
export default class AccountAddForm extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleReferenceNumberChange = (referenceNumber) => this._handleChange({ referenceNumber });
        this._handlePinChange = (pin) => this._handleChange({ pin });
        this.state = {
            referenceNumber: "",
            pin: ""
        };
        this._handleSubmit = this._handleSubmit.bind(this);
    }
    render() {
        const { props } = this;
        const { value } = props;
        const errors = getErrors(value, props.accts.data || []);
        const isValid = Object.values(errors).every(it => it == null);
        const { globalError } = mapBackendErrors(props.fieldErrors);
        return (<Form isBusy={props.isLoading} isValid={isValid} onSubmit={this._handleSubmit} submitLabel={messages.submit} error={globalError}>
				<fieldset className="fieldset">
					<legend>
						<span className="u-isVisuallyHidden">
							<FormattedMessage id="forms.accountAdd.legend" defaultMessage="Account Information"/>
						</span>
					</legend>

					<TextFormGroup name="referenceNumber" className="form-group-referenceNumber" type="number" label={messages.referenceNumberLabel} help={messages.referenceNumberHelp} value={value.referenceNumber} onChange={this._handleReferenceNumberChange} error={errors.referenceNumber} required/>

					<TextFormGroup name="pin" className="form-group-pin" type="number" label={messages.pinLabel} help={messages.pinHelp} value={value.pin} onChange={this._handlePinChange} error={errors.pin} required/>
				</fieldset>
			</Form>);
    }
    _handleChange(value) {
        this.props.onChange({
            ...this.props.value,
            ...value
        });
    }
    _handleSubmit() {
        this.props.addAccount(this.props.value);
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/AccountAddForm.tsx